import { WarehouseWorkingDay } from "services/api/fleet/warehouses/types";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

import { WarehouseWorkingHoursPreset } from "./types";

export const WAREHOUSE_WORKDAYS = [1, 2, 3, 4, 5];

/** Najčešći rasporedi, da se tjedan ne upisuje dan po dan. */
export const WAREHOUSE_WORKING_HOURS_PRESETS: WarehouseWorkingHoursPreset[] = [
  { key: "workdays", label: "Radni dani, 08:00 do 16:00", openDays: WAREHOUSE_WORKDAYS, from: "08:00", to: "16:00" },
  { key: "workdaysSaturday", label: "Radni dani i subota", openDays: [1, 2, 3, 4, 5, 6], from: "08:00", to: "16:00" },
  { key: "nonstop", label: "Svaki dan, 0 do 24 h", openDays: [1, 2, 3, 4, 5, 6, 7], from: "00:00", to: "24:00" },
];

/**
 * Vremena u 24 satnom obliku, svakih 30 minuta, od 00:00 do 24:00. Nativno polje za vrijeme
 * prikazuje AM i PM ovisno o jeziku preglednika, pa se vrijeme bira s popisa.
 */
export const WAREHOUSE_TIME_OPTIONS: DropdownOption[] = Array.from({ length: 49 }, (_, index) => {
  const hours = String(Math.floor(index / 2)).padStart(2, "0");
  const minutes = index % 2 === 0 ? "00" : "30";
  const time = `${hours}:${minutes}`;
  return { value: time, text: time };
});

/** Radi li dan, a kraj nije nakon početka. Vrijeme je "HH:mm", pa se uspoređuje kao tekst. */
export const isInvalidWorkingDay = (workingDay: WarehouseWorkingDay) =>
  workingDay.isOpen && (!workingDay.from || !workingDay.to || workingDay.from >= workingDay.to);
